import axios from "axios";
import SignalContent from "../signal_content";
import { RequestSignallampParamsMaker } from "./make_signallamp_request_params";
import { getSignallampSetting } from "./get_signallamp_setting";
import { applySignallampSetting, checkSignallampSettingsThatMatchSelectDeviceId } from "./apply_setting";
import { updateAndGetAndApplyComponentSetting, updateAndGetAndApplySetting } from "./update_and_get_and_apply_settings";
import { i18n } from "@/main";

/**
 * 保存ボタン通常状態
 * @param {SignalContent} self
 */
const switchDefault = (self: SignalContent) => {
  self.submitButton = true;
  self.submitWait = false;
  self.submitComplete = false;
};

/**
 * 保存ボタン保存中状態
 * @param {SignalContent} self
 */
const switchWait = (self: SignalContent) => {
  self.submitButton = false;
  self.submitWait = true;
  self.submitComplete = false;
};

/**
 * 保存ボタン保存成功状態
 * @param {SignalContent} self
 */
const switchSuccess = (self: SignalContent) => {
  self.submitButton = false;
  self.submitWait = false;
  self.submitComplete = true;
};

export class SignallampStoreController {
  /**
   * デバイスIDの新規追加
   * @param self
   */
  public static async saveNewSignallampStore(self: SignalContent) {
    try {
      if (SignallampStoreController.validationCheck(self)) {
        switchWait(self as SignalContent);
        const updateResult = await updateAndGetAndApplySetting(self);
        if (!updateResult) {
          return;
        }
        switchSuccess(self as SignalContent);
        setTimeout(() => {
          switchDefault(self as SignalContent);
        }, 3000);
      }
    } catch (e) {
      console.error(e);
      switchDefault(self as SignalContent);
    }
  }

  /**
   * デバイスID(signallampStore)の削除
   * @param self
   */
  public static async remove(self: SignalContent) {
    try {
      let removeConfirmMessage: string = "";
      // 変数入りのメッセージが文法上おかしくないようif分岐
      if (i18n.locale === "ja") {
        removeConfirmMessage =
        `\"${self.signallampStoreName}\"`
        + self.$t("message.areYouSureYouWantToDeleteDeviceId")
      } else {
        removeConfirmMessage =
        self.$t("message.areYouSureYouWantToDeleteDeviceId")
        + `\"${self.signallampStoreName}\"`
        + self.$t("message.questionMark");
      }
      const removeConfirm = confirm(removeConfirmMessage);
      if (removeConfirm) {
        const signallampStoreName = self.signallampStoreName;
        const reqParams = RequestSignallampParamsMaker.makeDeleteSignallampSettingParams(
          self.signallampStoreName,
        );
        await axios(reqParams);
        self.authStoreProcessMsg = self.$t("message.credentialStoreWasDeletedSuccessfully") as string;
        if (signallampStoreName === self.selectDeviceId) {
          self.selectDeviceId = "";
          await updateAndGetAndApplyComponentSetting(self);
        }
        self.signallampStoreName = "";
        const settingApiResponse = await getSignallampSetting(self);
        if (settingApiResponse) {
          self.mstSignallampSettings = settingApiResponse.data.res.mst_signallamp_setting;
          checkSignallampSettingsThatMatchSelectDeviceId(self);
          applySignallampSetting(self);
        }
        setTimeout(() => {
          self.authStoreProcessMsg = "";
        }, 3000);
      }
      return;
    } catch (err) {
      console.error(err);
      alert(self.$t("message.failedToDeleteCredentialStore"));
      return err;
    }
  }

  /**
   * Component内のAuthStoresからremoveしたAuthStoreを削除
   * @param self
   * @param storeName
   */
  public static clear(self: SignalContent, storeName: string) {
    const removeIndex: number[] = [];
    self.authStores.forEach((store: any, index: number) => {
      if (storeName === store.store_name) {
        removeIndex.push(index);
      }
    });
    removeIndex.forEach((i: number) => {
      self.authStores.splice(i, 1);
    });
  }

  /**
   * 新規作成時のバリデーションチェック
   * スルー項目(必須ではない)
   * alertCheck
   * addMails
   * mailSendInterval
   * addLocation
   * @param self
   */
  public static validationCheck(self: SignalContent) {
    if (self.addDeviceId === "") {
      alert(self.$t("message.enterDeviceId"));
      return false;
    }
    if (self.newkeyColors[0] === "" && self.newkeyColors[1] === "" && self.newkeyColors[2] === "" && self.newkeyColors[3] === "") {
      alert(self.$t("message.selectAtLeast1ColorForStackLight"));
      return false;
    }
    if (self.addDbTable === "") {
      alert(self.$t("message.enterTableName"));
      return false;
    }
    return true;
  }
}
